export const queryKeys = {
  CONTRACT: 'CONTRACT',
  STATISTICS: 'contract-statistics',
  ONLINE_CONTRACT_CONFIG: 'ONLINE_CONTRACT_CONFIG',
  ONLINE_CONTRACT_CLIENT_SIGNATURE: 'ONLINE_CONTRACT_CLIENT_SIGNATURE',
  ONLINE_CONTRACT_HAS_ACCESS: 'ONLINE_CONTRACT_HAS_ACCESS',
  BDM_CONFIG: 'BDM_CONFIG'
};
